import {
  PhoneLoginKind,
  type PhoneLoginAccountCandidate,
  type UserDataLoginRecord,
  type UserLoginByPhoneOutput
} from '@navio/nsdk';

export type PhoneLoginSession = {
  token: string;
  user: UserDataLoginRecord;
};

export type PhoneLoginOutcome =
  | ({ kind: typeof PhoneLoginKind.LOGGED_IN } & PhoneLoginSession)
  | {
      kind: typeof PhoneLoginKind.ACCOUNT_SELECTION;
      accountSelectionToken: string;
      accounts: PhoneLoginAccountCandidate[];
    }
  | { kind: typeof PhoneLoginKind.SIGNUP_REQUIRED; signupChallengeToken: string };

export function getPhoneLoginOutcome(data: UserLoginByPhoneOutput): PhoneLoginOutcome | null {
  if (data.kind === PhoneLoginKind.LOGGED_IN && data.token?.length && data.user != null) {
    return { kind: PhoneLoginKind.LOGGED_IN, token: data.token, user: data.user };
  }
  const accounts = data.accounts;
  if (
    data.kind === PhoneLoginKind.ACCOUNT_SELECTION &&
    data.accountSelectionToken?.length &&
    accounts != null &&
    accounts.length > 0
  ) {
    return {
      kind: PhoneLoginKind.ACCOUNT_SELECTION,
      accountSelectionToken: data.accountSelectionToken,
      accounts
    };
  }
  if (data.kind === PhoneLoginKind.SIGNUP_REQUIRED && data.signupChallengeToken?.length) {
    return { kind: PhoneLoginKind.SIGNUP_REQUIRED, signupChallengeToken: data.signupChallengeToken };
  }
  return null;
}
